import { Table as BaseTable } from "@tiptap/extension-table";

export const Table = BaseTable.configure({ resizable: true, lastColumnResizable: false });
